export const RECOMMENDED_OUTFITS_OPEN_MODAL_EVENT =
  "RECOMMENDED_OUTFITS_OPEN_MODAL_EVENT";
